import styled from 'styled-components';

const CreateChargebeeCustomerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
`;

const FormSection = styled.div`
  flex: 2;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 20px 40px;
  border-right: 2px solid #d4d4d4;
  border-bottom: 2px solid #d4d4d4;
  border-collapse: collapse;
`;

const Title = styled.div`
  font-size: 27px;
  line-height: 37px;
  font-weight: 700;
  color: #000000;
`;

const InputSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin: 24px 0px;
`;

const DetailsOfInput = styled.div`
  flex: 1;
  margin-right: 25px;
  flex-direction: column;
  min-height: 49px;
  height: max-content;
  justify-content: center;
`;

const InputTitle = styled.div`
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  color: #000000;
`;

const InputFieldWithSubmit = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Input = styled.input`
  font-size: 16px;
  max-width: 275px;
  padding: 11px;
  font-weight: 400;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const CreateChargebeeCustomerButton = styled.button`
  width: max-content;
  font-size: 19px;
  line-height: 26px;
  font-weight: 700;
  padding: 11px 26px;
  background-color: ${props => (props.disabled ? '#eeeeee' : '#42ffbb')};
  box-shadow: 0px 2px 4px 0px rgba(129, 129, 129, 0.5);
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
`;

const ResultSection = styled.div`
  color: #038a59;
  font-size: 14px;
  font-weight: normal;
`;

const ErrorSection = styled.div`
  color: red;
  font-size: 14px;
  font-weight: normal;
`;

export {
  CreateChargebeeCustomerContainer,
  Title,
  FormSection,
  InputSection,
  DetailsOfInput,
  InputTitle,
  InputFieldWithSubmit,
  Input,
  CreateChargebeeCustomerButton,
  ResultSection,
  ErrorSection
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/CreateChargebeeCustomer/styles.js